import { isAuthenticated } from "../utils/authStorage";

const CartReducer = (state, action) => {
  const userIsAuthenticated = isAuthenticated();
  switch (action.type) {
    case 'SET_CART':
      return { ...state, items: action.payload };
    case 'ADD_TO_CART': {
      const existingItemIndex = state?.items?.findIndex(item => item.bookId === action.payload.bookId);
      if (existingItemIndex >= 0) {
        // Item exists, increment the quantity
        const updatedItems = state.items.map((item, index) => {
          if (index === existingItemIndex) {
            const newQuantity = userIsAuthenticated
            ? item.quantity + action.payload.quantity
            : 1;

          return { ...item, quantity: newQuantity };
          }
          return item;
        })
        return { ...state, items: updatedItems };
      }
      // Item doesn't exist, add new item
      return { ...state, items: [...state.items, { ...action.payload, quantity: action.payload.quantity || 1 }] };
    }
    case 'REMOVE_FROM_CART':
      return {
        ...state,
        items: state?.items?.filter(item => (item?.bookId || item?.giftVoucherId || item?.userBookId) !== action?.payload?.itemId),
      };
    case 'CLEAR_CART':
      return { ...state, items: [] };
    default:
      return state;
  }
};

export default CartReducer;
